export function mergeById<T extends { id: string }>(
  current: readonly T[],
  incoming: readonly T[],
): T[] {
  const byId = new Map(current.map((item) => [item.id, item] as const));
  for (const item of incoming) {
    byId.set(item.id, item);
  }
  return [...byId.values()];
}
